// PrivacyPolicy.jsx
import React from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaShieldAlt } from 'react-icons/fa';
import '../../../../../assets/css/customer/subscreens/account/PrivacySettings.css';
import MyNavbar from '../../../../../components/general/mynavbar/MyNavbar';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: '1. Information We Collect',
      content: [
        'We collect information when you create an account, place an order, or use our platform. This includes:',
        '• Personal information such as name, email address, phone number, and address',
        '• Shop details for sellers, including shop name, products, and documents submitted for approval',
        '• Order details, including products bought, order status, and delivery address',
        '• Messages sent through the "Chat with Seller" feature',
        '• Login information, stored securely to keep your account safe'
      ]
    },
    {
      title: '2. How We Use Your Information',
      content: [
        'We use the information we collect to:',
        '• Process and fulfill your orders',
        '• Let customers and sellers chat about products and orders',
        '• Send you notifications, such as order updates, shop or product approval status, and chat messages',
        '• Approve seller shops and products',
        '• Respond to your questions and provide support',
        '• Improve our platform and fix issues'
      ]
    },
    {
      title: '3. Information Sharing',
      content: [
        'We may share your information with:',
        '• The seller, so they can arrange delivery of your order (delivery is handled by the seller directly, not by CraftHive)',
        '• Service providers who help us operate the platform',
        'We do not sell your personal information to any third party.'
      ]
    },
    {
      title: '4. Orders, Delivery and Cancellations',
      content: [
        'Delivery is arranged by the seller, and a fixed delivery charge of Rs. 200 applies per order.',
        'Orders can only be cancelled before dispatch. Once an order is dispatched, it cannot be refunded.',
        'Order and delivery information is shared only as needed to complete your purchase.'
      ]
    },
    {
      title: '5. Data Security',
      content: [
        'We take reasonable steps to protect your personal information:',
        '• Secure storage of account and order data on our servers',
        '• Restricted access to sensitive information',
        '• Ongoing efforts to fix security issues as they are found',
        'However, no method of storage or transmission over the internet is 100% secure.'
      ]
    },
    {
      title: '6. Your Rights',
      content: [
        'You have the right to:',
        '• Access and update your personal information from your account settings',
        '• Request correction of inaccurate information',
        '• Request deletion of your account and personal data by contacting support',
        'Contact us through the Support page to exercise these rights.'
      ]
    },
    {
      title: '7. Local Storage',
      content: [
        'We use your browser\'s local storage to:',
        '• Keep you logged in during your session',
        '• Remember basic account details so pages load faster',
        'This information stays on your device and is used only to run the platform properly.'
      ]
    },
    {
      title: '8. Changes to This Policy',
      content: [
        'We may update this Privacy Policy from time to time.',
        'Any changes will be posted on this page with an updated date.',
        'Your continued use of CraftHive after changes indicates that you accept the updated policy.'
      ]
    },
    {
      title: '9. Contact Us',
      content: [
        'If you have questions about this Privacy Policy, please reach out to us through the Support page.',
        'We will do our best to respond to your inquiry as soon as possible.'
      ]
    }
  ];

  return (
    <>
    <MyNavbar/>
    <div className="privacy-policy-page">
      <Container>
        <div className="policy-shell-container">
          {/* Header */}
          <div className="policy-header">
            <button className="back-btn" onClick={() => navigate(-1)}>
              <FaArrowLeft size={20} />
            </button>
            <h1>Privacy Policy</h1>
            <div></div>
          </div>

          {/* Last Updated */}
          <p className="last-updated">
            Last Updated: September 7, 2026
          </p>

          {/* Introduction */}
          <div className="policy-intro">
            <p>
              At CraftHive, we care about your privacy and want you to feel safe using our platform. This Privacy Policy explains what information we collect from customers and sellers, how we use it, and how we keep it safe.
            </p>
          </div>

          {/* Policy Sections */}
          <div className="policy-sections">
            {sections.map((section, index) => (
              <div key={index} className="policy-section">
                <h3>{section.title}</h3>
                {section.content.map((paragraph, idx) => (
                  <p key={idx}>{paragraph}</p>
                ))}
              </div>
            ))}
            </div>
          </div>
      </Container>
    </div>
    </>
  );
};

export default PrivacyPolicy;